module.exports = __webpack_public_path__ + "static/images/styles/images/icons/icon-vehicle-types.f8829f4d.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/icons/icon-vehicle-types.png
// module id = 3637
// module chunks = 11